var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _path8, _path9, _g7, _path0, _g8, _path1, _g9, _path10, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 165,
    viewBox: "0 0 261 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1 32.1C75.1 32.1 72.3 5.70001 43.2 5.70001C14.1 5.70001 0.900012 24.7 1.50001 41.8C2.20001 60.1 10.5 72.7 15.9 80.2C20.7 86.9 25.3 92.2 33.3 95C38.9 96.9 42.2 109.8 44.5 113.5C46.8 117.2 51.4 122.5 59.3 121.8C67.2 121.1 75.3 114 75 102.4C74.8 92.5 71.8 89.1 71.8 89.1",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1002 50.6C56.1002 50.6 66.3002 42.7 61.2002 28.4C56.1002 14 36.9002 17.1 28.8002 19.1C21.0002 21 11.2002 31.1 11.2002 40.9C11.2002 50.6 13.5002 64 27.4002 78.9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0001 31.5C62.0001 31.5 41.9001 27 33.4001 37.3C26.7001 45.4 29.7001 55.8 35.3001 63.1C38.5001 67.2 46.3001 76.9 46.3001 87.2C46.3001 97.6 56.4001 96.8 58.9001 96.5C61.3001 96.1 64.5001 94 64.2001 88.6C63.9001 84.5 59.6001 82.5 59.6001 82.5C59.6001 82.5 54.8001 80.9 54.9001 76.5C55.0001 69.9 62.0001 71.7 62.6001 67.4C62.9001 65.3 62.7001 59.8 62.7001 59.8",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.6 32.1C185.6 32.1 188.4 5.70001 217.5 5.70001C246.6 5.70001 259.8 24.7 259.2 41.8C258.5 60.1 250.2 72.7 244.8 80.2C240 86.9 235.4 92.2 227.4 95C221.8 96.9 218.5 109.8 216.2 113.5C213.9 117.2 209.3 122.5 201.4 121.8C193.5 121.1 185.4 114 185.7 102.4C185.9 92.5 188.9 89.1 188.9 89.1",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.5 50.6C204.5 50.6 194.3 42.7 199.4 28.4C204.5 14 223.7 17.1 231.8 19.1C239.6 21 249.4 31.1 249.4 40.9C249.4 50.6 247.1 64 233.2 78.9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.7 31.5C198.7 31.5 218.8 27 227.3 37.3C234 45.4 231 55.8 225.4 63.1C222.2 67.2 214.4 76.9 214.4 87.2C214.4 97.6 204.3 96.8 201.8 96.5C199.4 96.1 196.2 94 196.5 88.6C196.8 84.5 201.1 82.5 201.1 82.5C201.1 82.5 205.9 80.9 205.8 76.5C205.7 69.9 198.7 71.7 198.1 67.4C197.8 65.3 198 59.8 198 59.8",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 127.71C112.32 132.559 107.18 137.904 102.832 140.279C98.9771 142.358 94.1342 143.149 89.8843 142.556C86.8205 142.358 79.309 141.269 78.4195 141.368C77.6288 141.467 77.2335 142.061 77.2335 142.952C77.3323 145.426 77.4312 147.801 77.4312 150.276C77.4312 153.344 77.4312 156.412 76.344 159.381C75.158 162.548 73.1813 163.736 69.3267 162.548C65.9663 161.46 63.8908 158.985 62.7048 155.818C61.3211 151.859 60.4316 147.9 61.42 143.545C62.3095 139.29 64.6815 136.518 68.9314 135.43C70.0186 135.133 70.5127 134.737 70.5127 133.45C70.4139 131.867 70.6116 130.184 70.8092 128.501C70.9081 127.71 71.0069 126.918 71.3034 126.324C72.2918 124.048 74.1696 123.355 76.8382 124.147C77.3323 124.345 77.8265 124.543 78.716 124.74C81.8787 126.324 84.9426 128.205 89.5878 129.491C91.4657 129.986 94.4307 130.184 97.5934 128.402C101.349 126.126 104.611 122.86 105.401 119",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 128.3C165.4 128.3 193.6 100 193.6 65.2C193.6 30.4 165.3 2.09998 130.5 2.09998C95.6999 2.09998 67.3999 30.4 67.3999 65.2C67.3999 100 95.6999 128.3 130.5 128.3Z",
    stroke: "#000000",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.5 83.1C165.349 83.1 193.6 74.683 193.6 64.3C193.6 53.917 165.349 45.5 130.5 45.5C95.6507 45.5 67.3999 53.917 67.3999 64.3C67.3999 74.683 95.6507 83.1 130.5 83.1Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.5 126.6C140.883 126.6 149.3 98.7521 149.3 64.4C149.3 30.0479 140.883 2.20001 130.5 2.20001C120.117 2.20001 111.7 30.0479 111.7 64.4C111.7 98.7521 120.117 126.6 130.5 126.6Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7002 65.1C91.7002 100 109.1 128.2 130.5 128.2C151.9 128.2 169.3 99.9 169.3 65.1C169.3 30.3 151.9 2 130.5 2C109.1 2 91.7002 30.2 91.7002 65.1Z",
    stroke: "#000000",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_51_1111",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 261,
    height: 165
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.7 0.5H0V164.9H260.7V0.5Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_51_1111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.8 116C168.4 117.5 168.9 118.9 169.1 120.2C169.9 124.6 169.5 128.8 167.7 132.9C166.6 135.8 163.3 142.9 163.1 143.8C163 144.6 163.4 145.2 164.3 145.4C166.7 146 169.1 146.7 171.5 147.3C174.5 148.2 177.5 149.1 180.1 151C182.9 153.1 183.4 155.4 181.1 158.8C179.1 161.8 176 163.1 172.6 163.2C168.4 163.4 164.2 163 160.3 160.8C156.4 158.6 154.5 155.5 154.6 151.1C154.6 149.9 154.4 149.3 153.2 149C151.6 148.6 150 147.9 148.5 147.2C147.8 146.9 147 146.6 146.5 146.1C144.6 144.5 144.4 142.4 146 140.1C146.3 139.6 146.7 139.2 147.2 138.5C149.6 135.9 152.4 133.5 155.1 129.3C156 127.9 156.8 124.3 156.7 121.6",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo2.472a5260248b31095db6a2d0cb1e6f35.svg";
export { ForwardRef as ReactComponent };